import { generateRandomId } from '@utils/utils';


export const a11yLabels = {
  BOT_NAME: 'Visa AI Virtual Assistant',
  CHAT_WINDOW: 'Visa Virtual Chat Assistant window',
  MINIMIZE_BUTTON: 'Minimize Visa AI Virtual Assistant',
  CLOSE_BUTTON: 'Close Visa AI Virtual Assistant',
  CLEAR_MESSAGE_BUTTON: 'Clear your Message',
  SEND_MESSAGE_BUTTON: 'Send Message',
  LIKE_BUTTON: 'Like',
  DISLIKE_BUTTON: 'Dislike',
  RESPONDING_ACTION: 'Responding',
  NEW_WINDOW_LINK: 'Open in new window',
  EXTERNAL_LINK: 'External Link',
  ONGOING_CHAT: 'Ongoing Chat',
  DISCLAIMER_CHAT:'Close Disclaimer to acknowledge the use of the AI Chatbot'
};


export const defaultDataJson = {
  mainMenuItems: [
    {
      menuItem: "I'm interested in a product",
      menuItemResponse:
        'Ask me anything to learn more about a product.<br>\r\n<br>\r\n<a href="https://globalclient.visa.com/contact-sales">Contact sales</a>&nbsp;to talk to a Visa representative about purchasing a product.',
      disableNextSteps: 'false'
    },
    {
      menuItem: 'Get help with a product I use',
      menuItemResponse:
        'Existing Visa customers can get product support and technical documentation on&nbsp;<a href="https://www.visaonline.com/">Visa Online</a>&nbsp;or through the&nbsp;<a href="https://ltr.review.visa.com/support.html">Visa Support Hub</a>.<br>\r\n<br>\r\nVisit the&nbsp;<a href="https://ltr.review.visa.com/contact-us.html">Contact Us page for cardholder support.</a>',
      disableNextSteps: 'false'
    },
    {
      menuItem: 'Become a Visa partner',
      menuItemResponse: 'Visit the&nbsp;<a href="https://partner.visa.com/">Visa Partner Portal</a>&nbsp;to learn more about becoming a Visa partner.',
      disableNextSteps: 'false'
    },
  ],
  acceptOption: 'Yes',
  legalDescriptionHeading: 'Description',
  legalDescriptionText: 'User acknowledges and accepts that this service is intended to provide general information about Visa Accompanist and does not substitute any legal, compliance, or policy advice. User will at all times comply with the Visa Accompanist &lt;a data-linktype&#x3D;&quot;external&quot; data-link-external-ref&#x3D;&quot;https:&#x2F;&#x2F;usa.visa.com&#x2F;legal.html&quot; data-is-no-follow&#x3D;&quot;false&quot; data-in-same-tab&#x3D;&quot;false&quot; data-in-new-tab&#x3D;&quot;true&quot; data-is-modal&#x3D;&quot;false&quot; data-conversiontype&#x3D;&quot;Not a Conversion&quot; data-is-anchor-tag&#x3D;&quot;false&quot; data-aria-label&#x3D;&quot;Open in new window, External Link&quot; aria-label&#x3D;&quot;User acknowledges and accepts that this service is intended to provide general information about Visa Accompanist and does not substitute any legal, compliance, or policy advice. User will at all times comply with the Visa Accompanist Terms of Use (Open in new window, External Link)&quot; href&#x3D;&quot;https:&#x2F;&#x2F;usa.visa.com&#x2F;legal.html&quot; class&#x3D;&quot;vs-link-cta vs-link-new-window vs-link-inline&quot; target&#x3D;&quot;_blank&quot;&gt;Terms of Use&lt;&#x2F;a&gt;',
  acceptOptionResponse: 'Ask Me Anything!',
  welcomeText: 'Hi! I’m Visa’s Virtual Assistant powered by AI. I can help you learn about Visa’s products and services. While I may not have all the details, I’m happy to help with general questions and guide you to the right resources for more in-depth assistance.',
  confirmationDialogLabel: 'Is there anything else I can help you with?',
  declineOption: 'No',
  chatBotHeading: "Let's Chat",
  mainMenuLinkText: 'View main menu',
  sourcesText: 'Sources',
  suggestedHelpQuestions: 'Suggested Help Questions',
  contactSalesText: 'Contact sales',
  contactSalesUrl: 'https://globalclient.visa.com/contact-sales',
  endChatHeading: 'End chat?',
  endChatSubHeading: 'When you click End Chat, your session will end.',
  endChatButtonText: 'Yes, end chat',
  cancelText: 'Cancel and go back',
  typeMessagePlaceholderText: 'Type a message...',
  chatbotErrorMsg: "We're momentarily offline due to technical issues. We're working diligently to restore services. Thank you for your understanding.",
  displayTimeInMiliSeconds: 0,
  mainMenuHelpText: 'I can also help you with:',
  declineOptionResponse:
    'Ok, great! Happy to assist. Remember that I’m here to answer any questions you have about Visa products and solutions. If you’re done you can end the chat.',
};
export const renderUserMessage = (id, userInput) => {
  return `<div class="message user" id=${id}>
        <p class="vs-user-input-bot">${userInput}</p>
      </div>`;
};

export const hasExternalLink = (link) =>{
    const sourceUrl = new URL(link) || '';
    const hostname = window.location.hostname || '';
    return sourceUrl && hostname && sourceUrl.hostname!==hostname;
}

export const renderButton = question => {
  return `<button class="visa-document-button"
            aria-label="${question}" >
            <span class="visa-icon visa-icon-search-md"></span>
            <span class="vs-text-left">${question}</span></button>`;
};

export const renderSuggestedQuestionsHeader = (questions) => {
  return `<h2 class="vs-lead vs-meta vs-mb-1 vs-pl-2 vs-mt-1">${questions}</h2>`;
};

export const toggleChatBox = ($this) => {
  const body = document.body;
  if ($this.isMinimized) {
    $this.chatContainerElement.classList.remove('vs-d-none');
    $this.isMinimized = false;
    $this.chatBoxVisible = true;
    $this.chatExpansionData = 'chat-open';
    const chatBoxEl = document.querySelector<HTMLElement>('.vs-chat-container');
    chatBoxEl.focus();
    body.classList.add('no-page-scroll');
    return;
  }
  $this.chatBoxVisible = !$this.chatBoxVisible;
  $this.chatExpansionData = $this.chatBoxVisible ? 'chat-open' : 'chat-closed';
  $this.animationClass = $this.chatBoxVisible ? 'opening' : '';

  //Need to revisit when minimize functionality is added
  if ($this.chatBoxVisible) {
    setTimeout(() => {
      const chatBoxEl = document.querySelector<HTMLElement>('.vs-chat-container');
      chatBoxEl.focus();
    }, 400);
    body.classList.add('no-page-scroll');
    const randomId = crypto.randomUUID() || generateRandomId();
    localStorage.setItem('visaAssistSessionId', `${randomId}`);

    $this.showEndChatScreen = false;
  } else {
    localStorage.removeItem('visaAssistSessionId');
    const chatButton = document.querySelector<HTMLElement>('.vs-chat-main-container .vs-sticky-button');
    setTimeout(() => chatButton.focus(), 100);
    clearTimeout($this.chatMainMenuTimerObj);
    body.classList.remove('no-page-scroll');
  }
};

export const minimizeChatbox = $this => {
  $this.chatContainerElement.classList.add('vs-d-none');
  $this.isMinimized = true;
  const stickyContainer: any = document.querySelector('.vs-chat-sticky-button-container');
  stickyContainer.classList.remove('vs-d-none');
  $this.chatBoxVisible = true;
  $this.showEndChatScreen = false;
  const chatButton = document.querySelector<HTMLElement>('.vs-chat-main-container .vs-sticky-button');
  $this.chatExpansionData = 'chat-closed';
  const body = document.body;
  body.classList.remove('no-page-scroll');

  chatButton.focus();
};

export const renderBotMainMenu = ($this) => {
  const mainMenuItems = $this.jsonObject.mainMenuItems;
  const mainMenuHelpText = $this.jsonObject.mainMenuHelpText;

  let mainMenuMarkup = '';
  mainMenuItems.forEach((mainMenuItem, index) => {
    mainMenuMarkup += `<div role="button" class="line vs-chat-options" data-type="${index}" tabindex="0">${mainMenuItem.menuItem}</div>`;
  });
  const markup = `<div class="message chatbot">
              <span class="vs-message-brain-icon"><span class="vs-sr-only">${$this.jsonObject.chatBotAllyLabels.botNameAllyLabel}</span></span>
              <div class="vs-bot-response">
                <p class="">${mainMenuHelpText}</p>
                <div class="vs-chat-box-element">
                  ${mainMenuMarkup}
                </div>
              </div>
            </div>`;

  const htmlMarkup: HTMLElement | any = parseFromStringToHtml(markup);
  htmlMarkup.addEventListener('click', (e) => $this.handleMainMenuClickEvents(e));
  // START GENAI@CHATGPT4
  htmlMarkup.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
        $this.handleMainMenuClickEvents(e);
        e.preventDefault();
    }
  });
  // END GENAI@CHATGPT4
  $this.chatContainer.appendChild(htmlMarkup);
  const chatHistoryDom = document.querySelector('.chat-history');
  const lastChild = chatHistoryDom.lastChild;
  smoothScrollIntoView(lastChild, 'end');
  $this.disableChatButton = false;
};

export const renderContactUs = (contactSalesUrl, contactSalesText) => {
  return `<div class="vs-d-flex-align-c"><button onclick="window.open('${contactSalesUrl}', '_blank')" type="submit" class="vs-btn vs-btn-primary vs-btn-new-window vs-mt-20 submit-button vs-btn-icon vs-mb-2">${contactSalesText}</button></div>`;
};

export const renderMainMenuLink = (mainMenuLinkText) => {
  return `<a class="vs-link-cta vs-main-menu-link vs-d-flex-align-c" aria-label="" target="_self" data-conversiontype="Not a Conversion" href="javascript:void(0)">${mainMenuLinkText}</a>`;
};

export const parseFromStringToHtml = stringElem => {
  const domParser = new DOMParser();
  const htmlDOM = domParser.parseFromString(stringElem, 'text/html');
  return htmlDOM.body.firstChild;
};

export const parseFromStringToHtmlElement = stringElem => {
  const domParser = new DOMParser();
  const htmlDOM = domParser.parseFromString(stringElem, 'text/html');
  return htmlDOM.body.outerHTML;
};

export const renderBotMessage = (stringElem, botNameAllyLabel, id = '') => {
  // START GENAI@CHATGPT4
  return `<div class="message chatbot">
    <span class="vs-message-brain-icon"><span class="vs-sr-only">${botNameAllyLabel}</span></span>
    <div class="vs-bot-response">
      <p class="" ${id ? ` id="${id}"` : ''}>
        ${stringElem}
      </p>
    </div>
  </div>`;
  // END GENAI@CHATGPT4
};

export const renderBotWelcomeMessage = (welcomeText, botNameAllyLabel) => {
  const text = `${welcomeText}`;
  return renderBotMessage(text, botNameAllyLabel);
};

export const renderLoader = (respondingActionButtonAllyLabel) => {
  return `<div class="message chatbot loader" id="loader">
  <div class="vs-grey-bg">
    <div data-title="dot-typing">
      <div class="dot-typing"><div class="vs-sr-only">${respondingActionButtonAllyLabel}</div></div>
</div>
  </div>
</div>`;
};

export const renderMainMenuMarkup = (chatContainerRef, chatMenuItems, botNameAllyLabel) => {
  const randomNo = generateRandomId();
  const botStr = chatMenuItems.menuItemResponse;
  const userStr = chatMenuItems.menuItem;
  const markupStr = renderUserMessage(randomNo, userStr);
  const markup = parseFromStringToHtml(markupStr);
  chatContainerRef.append(markup);
  smoothScrollIntoView(markup, 'end');
  const botMarkup = parseFromStringToHtml(renderBotMessage(botStr, botNameAllyLabel));
  setTimeout(() => chatContainerRef.append(botMarkup), 500);
  setTimeout(() => smoothScrollIntoView(botMarkup, 'end'), 1000);
};

export const smoothScrollIntoView = (elem, pos = 'start') => {
  elem?.scrollIntoView({ behavior: 'smooth', block: pos });
};

export const renderShimmer = () => {
  return `<div class="shimmer-wrapper loader" id="loader">
  <div class="column">
    <div class="shimmer-circle shimmer-circle-md shimmer-animate"></div>
  </div>
  <div class="column shimmer-l-column">
    <div class="shimmer-line shimmer-line-br shimmer-line-80 shimmer-animate"></div>
    <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></div>
    <div class="shimmer-line shimmer-line-br shimmer-line-full shimmer-animate"></div>
  </div>
</div>`;
};

export const renderConfirmationDialogue = ($this) => {

  const markup = `<div class="message chatbot">
              <span class="vs-message-brain-icon"><span class="vs-sr-only">${$this.jsonObject.chatBotAllyLabels.botNameAllyLabel}</span></span>
              <div class="vs-bot-response">
                <p class="">${$this.jsonObject.confirmationDialogLabel}</p>
                <div class="vs-chat-box-element">
                  <div role="button" class="line vs-chat-selection" tabindex="0" data-val="true">
                  ${$this.jsonObject.acceptOption}
                  </div>
                  <div role="button" class="line vs-chat-selection" tabindex=0" data-val="false">
                   ${$this.jsonObject.declineOption}
                  </div>
                </div>
              </div>
            </div>`;

  const htmlMarkup: HTMLElement | any = parseFromStringToHtml(markup);
  const confirmationDivElem = htmlMarkup.querySelector('.vs-chat-box-element');
  confirmationDivElem?.addEventListener('click', (e)=>$this.handleConfirmationDialogue(e));
  // START GENAI@CHATGPT4
  confirmationDivElem?.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
        $this.handleConfirmationDialogue(e, false);
        e.preventDefault();
    }
  });
  // END GENAI@CHATGPT4
  $this.chatContainer.appendChild(htmlMarkup);
  setTimeout(() => smoothScrollIntoView(htmlMarkup), 300);
};

export const startMainMenuCounter = ($this) => {
  $this.chatMainMenuTimerObj = setTimeout(() => {
    const isUserInitiatedChat = $this.chatContainer.querySelector('.user');
    if (!isUserInitiatedChat) {
      renderBotMainMenu($this);
      $this.disableChatButton = true;
    }
    const chatBoxEl = document.querySelector<HTMLElement>('.vs-chat-container');
    chatBoxEl?.focus();
  }, $this.jsonObject.displayTimeInMiliSeconds);
};

